export const GT = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="5"
      height="8"
      viewBox="0 0 5 8"
      fill="none"
      cursor="unset"
      className="w-6 relative top-2"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.219671 0.719669C0.512564 0.426776 0.987438 0.426777 1.28033 0.719671L4.01517 3.45451C4.45451 3.89385 4.4545 4.60616 4.01516 5.0455L1.28033 7.78033C0.987436 8.07322 0.512563 8.07322 0.21967 7.78033C-0.0732233 7.48744 -0.0732228 7.01256 0.219671 6.71967L2.68934 4.25001L0.219669 1.78033C-0.0732236 1.48744 -0.0732231 1.01256 0.219671 0.719669Z"
        fill="#FFFFFF"
      ></path>
    </svg>
  );
};
